// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1kALw","modal":"Modal_modal__3lFwL","slide-down":"Modal_slide-down__chNUC"};